import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'lin-app-stote-and-google-badges',
  templateUrl: 'app-store-and-google-badges.component.html',
  styleUrls: ['./app-store-and-google-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppStoreAndGoogleBadgesComponent {
  @Input() linkAppStore: string
  @Input() linkPlayMarket: string
}
